import React, { useEffect, useState } from 'react';
import { VoiceOptions, VoiceSummary, defaultVoiceOptions } from './VoiceCalculator';
import { calculateVoiceQuote } from '../utils/voicePricing';
import { submitVoiceApplication } from '../utils/submitVoiceApplication';
export default function VoiceApplication({ job, options: sharedOptions, onOptionsChange }) {
  const [localOptions, setLocalOptions] = useState(defaultVoiceOptions);
  const options = sharedOptions || localOptions;
  const setOptions = onOptionsChange || setLocalOptions;
  const localDate = date => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  const today = localDate(new Date());
  const [availability, setAvailability] = useState(() => { const date = new Date(); date.setDate(date.getDate() + 7); return localDate(date); });
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [mailFallback, setMailFallback] = useState(null);
  useEffect(() => { setMailFallback(null); setStatus(null); }, [options.rate, options.binaural, options.video, job.chapter]);
  let quote, quoteError;
  try { quote = calculateVoiceQuote(job.text, { ...options, withholding: true }); } catch (error) { quoteError = error.message; }
  async function submit(e) {
    e.preventDefault();
    const form = e.currentTarget;
    const fields = Object.fromEntries(new FormData(form));
    setBusy(true); setStatus(null); setMailFallback(null);
    try {
      const result = await submitVoiceApplication({ ...fields, chapter: job.chapter, binaural: options.binaural, video: options.video, rate: options.rate });
      if (!result.delivered) {
        setMailFallback(result); setStatus(result.message); return;
      }
      setSent(true); setStatus('応募を送信しました。担当者からの連絡をお待ちください。');
    } catch (e) { setStatus(e.message === 'Failed to fetch' ? '通信に失敗しました。時間をおいて再試行してください。' : e.message); }
    finally { setBusy(false); }
  }
  return <section className="jobs-contact voice-form" id="application"><h2>この案件に応募する</h2><p>希望する単価と収録形式を選んでご応募ください。単価の初期値は1.5円です。変更した単価は希望条件として送信され、正式な報酬は依頼前に合意します。</p>
    <form onSubmit={submit} onChange={() => { setMailFallback(null); setStatus(null); }}><fieldset disabled={busy || sent}><legend>応募内容</legend>
      <VoiceOptions options={options} onChange={setOptions} showWithholding={false} />
      {quote && <VoiceSummary quote={quote} />}
      {quoteError && <p role="alert">{quoteError}</p>}
      <label>お名前・活動名（必須）<input name="name" required maxLength="120" /></label>
      <label>メールアドレス（必須）<input name="email" type="email" required maxLength="255" /></label>
      <label>ボイスサンプルURL（必須）<input name="sample" type="url" required maxLength="1000" placeholder="https://" /></label>
      <label>納品可能日（必須・初期値は今日から1週間後）<input name="availability" type="date" required min={today} value={availability} onChange={e => setAvailability(e.target.value)} /></label>
      <label>自己紹介・収録環境・ご質問（必須）<textarea name="message" required rows="5" maxLength="3000" /></label>
      <label><input type="checkbox" required name="consent" value="yes" /> 募集内容と<a href="/privacy" target="_blank" rel="noreferrer">プライバシーポリシー</a>を確認し、応募情報を選考・連絡に使用することに同意します。</label>
      <button type="submit" disabled={!quote}>{busy ? '送信中…' : sent ? '送信済み' : 'この内容で応募する'}</button>
    </fieldset></form>{status && <p role="status">{status}</p>}
    {mailFallback && <div className="voice-mail-fallback">
      <a className="jobs-apply" href={mailFallback.mailto}>入力内容をメールアプリで開く</a>
      <p>この時点では応募は送信されていません。メールアプリで送信すると応募できます。</p>
      <details><summary>メールアプリが開かない場合</summary><p>下の応募内容をコピーし、kei@sugano.works 宛てにメールを送ってください。</p><textarea aria-label="メール応募用の内容" readOnly rows="10" value={mailFallback.applicationText} onFocus={e => e.target.select()} /></details>
    </div>}
    <p>お問い合わせ：<a href="mailto:kei@sugano.works">kei@sugano.works</a></p>
  </section>;
}
